module.exports = __webpack_public_path__ + "img/map1.f15d8b12.png";